import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
import { MatchValidatorDirective } from '../../../../shared/validators/match.directive';
import { ClientPasswordRecoveryTokenModel } from '../../../../shared/models/client-password-recovery-token.model';
import { PasswordRecoveryStepsService } from '../../../services/password-recovery-steps.service';

@Component({
    selector: 'payment-identification-password-recovery-receive-token',
    templateUrl: './payment.identification.password-recovery.receive-token.component.html',
    styleUrls: ['../../../payment.component.scss'],
    providers: [{
        provide: NG_VALIDATORS,
        useExisting: MatchValidatorDirective,
        multi: true
    }]
})
export class PaymentIdentificationPasswordRecoveryReceiveTokenComponent {
    public tokenModel = '';
    public refusedErr = '';
    public refused = false;
    @Output() validatedToken: EventEmitter<string> = new EventEmitter();
    @Output() canceled: EventEmitter<null> = new EventEmitter();
    @Input() email = '';

    constructor(
        protected passwordRecoveryService: PasswordRecoveryStepsService
    ) { }

    /**
     * validatedToken event emitter.
     **/
    public validateToken() {
        this.passwordRecoveryService.validateToken(
            this.tokenModel,
            ClientPasswordRecoveryTokenModel.TYPE_NEW_PASSWORD_VERIFICATION_CODE
        ).subscribe(() => {
            this.validatedToken.emit(this.tokenModel);
        }, (err) => {
            this.refused = true;
            this.refusedErr = err.hint;
        });
    }
    /**
     * This resets refused flag and message.
     **/
    public resetRefused() {
        this.refused = false;
        this.refusedErr = '';
    }
    public cancel() {
        this.refused = false;
        this.refusedErr = '';
        this.tokenModel = '';
        this.canceled.emit();
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/payment/identification/password-recovery/receive-token/payment.identification.password-recovery.receive-token.component.ts